export default "__VITE_ASSET__Duf9SMz5__"